import withLocale from '../IntlProvider/withLocale';
import Pagination from './Pagination';
export default withLocale(['Pagination'])(Pagination);